export class IRegisterSurvey{
  id: number;
  status: string;
  title: string;
  description: string;
  url: string;
  user: string;
  constructor(def:any){
    this.id = def.id || null;
    this.status = def.status || "";
    this.title = def.title || "";
    this.description = def.description || "";
    this.url = def.url || "";
    this.user = def.user || "";
  }
}